var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"material-selector-container"},_vm._l((_vm.displayList),function(option){return _c('material-selector',{key:option.key,attrs:{"options":option,"value":_vm.params[option.key]},on:{"input":function($event){return _vm.updateOptions($event, option)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }